// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"fa4a0e35","369":"e3fcbf22","615":"0c518821","753":"bdfc6e5b","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};